import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getUserSession } from "../api/User/userApi";
import UserSession, {userSessionInitial} from "../models/User/UserSession";

interface ApplicationState {
  userSession: UserSession;
}

const initialState: ApplicationState = {
  userSession: userSessionInitial,
};

export const getUser = createAsyncThunk("application/getUser", async () => {
  const user = await getUserSession();
  return user;
});

const applicationSlice = createSlice({
  name: "application",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getUser.fulfilled, (state, { payload }) => {
      state.userSession = payload;
    });
  },
});

export default applicationSlice.reducer;
